/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Practice_CtaInputs */

const en_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice Hub`)
};

const es_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de práctica`)
};

const de_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungszentrum`)
};

const zh_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习中心`)
};

const ar_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز التدريب`)
};

const fr_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de pratique`)
};

const vi_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trung tâm luyện tập`)
};

const sw_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitovu cha Mazoezi`)
};

const th_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ศูนย์ฝึกซ้อม`)
};

const bs_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centar za vježbu`)
};

const ja_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`練習センター`)
};

const ko_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연습 센터`)
};

const pt_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central de prática`)
};

const it_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro di allenamento`)
};

const sv_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Träningscenter`)
};

const nl_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefencentrum`)
};

const da_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træningscenter`)
};

const nb_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningssenter`)
};

const fi_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoituskeskus`)
};

const pl_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum treningowe`)
};

const ru_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренировочный центр`)
};

const tr_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrenman Merkezi`)
};

const hi_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभ्यास केंद्र`)
};

const id_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Latihan`)
};

const ms_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hab Latihan`)
};

const cs_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tréninkové centrum`)
};

const el_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κέντρο εξάσκησης`)
};

const he_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מרכז תרגול`)
};

const af_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefensentrum`)
};

const hu_lessons_practice_cta = /** @type {(inputs: Lessons_Practice_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlóközpont`)
};

/**
* | output |
* | --- |
* | "Practice Hub" |
*
* @param {Lessons_Practice_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_practice_cta = /** @type {((inputs?: Lessons_Practice_CtaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Practice_CtaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_practice_cta(inputs)
	if (locale === "de") return de_lessons_practice_cta(inputs)
	if (locale === "zh") return zh_lessons_practice_cta(inputs)
	if (locale === "ar") return ar_lessons_practice_cta(inputs)
	if (locale === "fr") return fr_lessons_practice_cta(inputs)
	if (locale === "vi") return vi_lessons_practice_cta(inputs)
	if (locale === "sw") return sw_lessons_practice_cta(inputs)
	if (locale === "th") return th_lessons_practice_cta(inputs)
	if (locale === "bs") return bs_lessons_practice_cta(inputs)
	if (locale === "ja") return ja_lessons_practice_cta(inputs)
	if (locale === "ko") return ko_lessons_practice_cta(inputs)
	if (locale === "pt") return pt_lessons_practice_cta(inputs)
	if (locale === "it") return it_lessons_practice_cta(inputs)
	if (locale === "sv") return sv_lessons_practice_cta(inputs)
	if (locale === "nl") return nl_lessons_practice_cta(inputs)
	if (locale === "da") return da_lessons_practice_cta(inputs)
	if (locale === "nb") return nb_lessons_practice_cta(inputs)
	if (locale === "fi") return fi_lessons_practice_cta(inputs)
	if (locale === "pl") return pl_lessons_practice_cta(inputs)
	if (locale === "ru") return ru_lessons_practice_cta(inputs)
	if (locale === "tr") return tr_lessons_practice_cta(inputs)
	if (locale === "hi") return hi_lessons_practice_cta(inputs)
	if (locale === "id") return id_lessons_practice_cta(inputs)
	if (locale === "ms") return ms_lessons_practice_cta(inputs)
	if (locale === "cs") return cs_lessons_practice_cta(inputs)
	if (locale === "el") return el_lessons_practice_cta(inputs)
	if (locale === "he") return he_lessons_practice_cta(inputs)
	if (locale === "af") return af_lessons_practice_cta(inputs)
	if (locale === "hu") return hu_lessons_practice_cta(inputs)
	return en_lessons_practice_cta(inputs)
});